import { IExample, IFeature, IFeatureItem, ITab } from "models";

export const INDUSTRIES = [
  'Pərakəndə Mağazalar',
  'Restoranlar və Kafelər',
  'Ərzaq Mağazaları',
  'Gözəllik Salonları',
  'Elektronika Mağazaları',
  'Xidmət Təminatçıları'
];


export const FEATURES: IFeature[] = [
  {
    title: 'Təhlükəsiz',
    description: 'Bütün məlumatlarınız şifrələnmiş şəkildə saxlanılır və qorunur.',
    icon: '🔒'
  },
  {
    title: 'Sürətli',
    description: 'Yüksək performans və sürətli əməliyyatlar üçün optimize edilmişdir.',
    icon: '⚡'
  },
  {
    title: 'Etibarlı',
    description: '24/7 dəstək və 99.9% uptime zəmanəti ilə daim xidmətinizdəyik.',
    icon: '✓'
  },
  {
    title: 'Çevik',
    description: 'Hər növ biznes üçün uyğunlaşdırıla bilən modullar və parametrlər.',
    icon: '🔧'
  },
  {
    title: 'Güclü Hesabatlar',
    description: 'Detallı satış hesabatları və analitika ilə biznesinizi idarə edin.',
    icon: '📊'
  },
  {
    title: 'Multi-Platform',
    description: 'Desktop, web, mobil və tablet cihazlarda işləyir.',
    icon: '📱'
  }
];


export const SHOWCASES: IFeatureItem[] = [
  {
    icon: '🔐',
    title: 'QR Əsaslı Təhlükəsiz Giriş',
    description:
      'Cihazlar yalnız menecərlər tərəfindən QR kod vasitəsilə təhlükəsiz avtorizasiya edilir',
    color: 'green.500'
  },
  {
    icon: '👥',
    title: 'Rol Əsaslı İnterfeyslar',
    description:
      'Sahiblər, ofisiantlar, kassirlər, mühasiblər və menecərlər üçün fərqli görünüşlər',
    color: 'blue.500'
  },
  {
    icon: '📊',
    title: 'Canlı Statistika',
    description: 'Satış məlumatlarını, nöbvə statusunu və maliyyə göstəricilərini dərhal görün',
    color: 'purple.500'
  },
  {
    icon: '💳',
    title: 'Bonus Kart Sistemi',
    description: 'İnteqrasiya edilmiş bonus sistemi ilə müştəri loyallığını idarə edin',
    color: 'orange.500'
  }
];


export const EXAMPLES: IExample[] = [
  {
    title: 'Təhlükəsiz Giriş',
    description: 'İstifadəçiyə xüsusi icazələrlə PIN qorumalı giriş',
    image: '/assets/login-screen.png'
  },
  {
    title: 'Əməliyyat İdarəetməsi',
    description: 'Sərbəst məhsul məlumatları ilə satışları həyata keçirin',
    image: '/assets/payment-screen.jpeg'
  },
  {
    title: 'Parametrlər və Təhlükəsizlik',
    description: 'İstifadəçi icazələri, qaranlıq rejim və fərdiləşdirmə bilən parametrlər',
    image: '/assets/home-screen.jpeg'
  },
  {
    title: 'Statistika Paneli',
    description: 'Hərtərəfli hesabat və biznes məlumatları',
    image: '/assets/statistics-dashboard.png'
  },
  {
    title: 'İstifadəçi İdarəetməsi',
    description: 'Rol əsaslı giriş idarəetməsi və istifadəçi administrasiyası',
    image: '/assets/users-management.png'
  },
  {
    title: 'Fərdiləşdirmə İmkanları',
    description: 'Fərdiləşdirilə bilən sistem parametrləri və istifadəçi tərcihləri',
    image: '/assets/settings-screen.png'
  }
];

export const TABS: ITab[] = [
  {
    id: 'desktop',
    label: 'Masaüstü Tətbiqi',
    icon: '💻',
    solutions: [
      {
        title: 'Müxtəlif Platformalar',
        description:
          'Həm Linux, həm də Windows əməliyyat sistemlərində, sensor ekranlar və adi kompüterlərdə rahat işləyir.',
        icon: '🖥️'
      },
      {
        title: 'Məhsul və Səbət İdarəetməsi',
        description:
          'Səbətdən silmək üçün admin icazəsi tələb olunur. Hər sabət dəyişikliyi tarixçədə qeydə alınır.',
        icon: '🛒'
      },
      {
        title: 'Rol Əsaslı Panel Girişi',
        description:
          'Sahiblər, Adminlər və Mühasiblər hər biri üçün xüsusi icazələrlə ayrı interfeyslər.',
        icon: '👥'
      },
      {
        title: 'Mağaza və İstifadəçi İdarəetməsi',
        description:
          'Sahiblər çoxlu mağazalar və işçilər (kassir, ofisiant, menecer və s.) əlavə edə bilər.',
        icon: '🏪'
      },
      {
        title: 'Maliyyə Hesabatları və İxrac',
        description:
          'Mühasiblər mənfəətləri, xərcləri izləyə və bütün hesabları Excel-ə ixrac edə bilər.',
        icon: '📊'
      },
      {
        title: 'Cihaz İdarəetməsi',
        description:
          'Masaüstü və ya mobil cihazlar əlavə edin, giriş bloklayın/blokdan çıxarın və təhlükəsiz bağlantısı üçün təhlükəsiz QR yaradın.',
        icon: '📱'
      }
    ]
  },
  {
    id: 'web',
    label: 'Veb Platforma',
    icon: '🌐',
    solutions: [
      {
        title: 'Rol Əsaslı Panel Girişi',
        description:
          'Sahiblər, Adminlər və Mühasiblər hər biri üçün xüsusi icazələrlə ayrı interfeyslər.',
        icon: '👥'
      },
      {
        title: 'Mağaza və İstifadəçi İdarəetməsi',
        description:
          'Sahiblər çoxlu mağazalar və işçilər (kassir, ofisiant, menecer və s.) əlavə edə bilər.',
        icon: '🏪'
      },
      {
        title: 'Anbar və Məhsul İdarəetməsi',
        description:
          'Menecərlər məhsulları əlavə/redaktə edə, stok, qiymət, vergi, ölçü və rəngləri tənzimləyə bilər.',
        icon: '📦'
      },
      {
        title: 'Maliyyə Hesabatları və İxrac',
        description:
          'Mühasiblər mənfəətləri, xərcləri izləyə və bütün hesabları Excel-ə ixrac edə bilər.',
        icon: '📊'
      },
      {
        title: 'Cihaz İdarəetməsi',
        description:
          'Masaüstü və ya mobil cihazlar əlavə edin, giriş bloklayın/blokdan çıxarın və təhlükəsiz bağlantısı üçün təhlükəsiz QR yaradın.',
        icon: '📱'
      },
      {
        title: 'Toplu Məhsul İdxalı/İxracı',
        description:
          'Excel vasitəsilə məhsul yükləyin, kateqoriyalar yaradın, kampaniya əsaslı endirimləri tətbiq edin. Ölçətənlə üçün məhsulları sabitləyin.',
        icon: '📋'
      }
    ]
  },
  {
    id: 'mobile',
    label: 'Mobil Tətbiq',
    icon: '📱',
    solutions: [
      {
        title: 'QR Əsaslı Təhlükəsiz Giriş',
        description:
          'Mobil cihazlar yalnız menecərlər tərəfindən QR kod vasitəsilə sistemə əlavə edilir. Bir cihaz = bir istifadəçi sessiyası.',
        icon: '🔐'
      },
      {
        title: 'Rol Əsaslı İnterfeyslar',
        description:
          'Sahib: İşçi izləmə, satış hesabatları, mənfəət monitorinqi\nOfisiant: Canlı masa rezervasiyaları, sifariş idarəetməsi\nKassir: Gündəlik satışlar, ödənişlər, bonus kart dəstəyi',
        icon: '👤'
      },
      {
        title: 'Qaranlıq/İşıqlı Rejim və Fərdiləşdirmə',
        description: 'Tətbiqin rejimini, dilini, PIN və ya şifrəli asanlıqla dəyişdirin.',
        icon: '🌓'
      },
      {
        title: 'Canlı Statistika',
        description:
          'Ən son satışları, nəvbə statusunu və ödəmiş üsulu bölgüsünü telefonunuzdan canlı izləyin.',
        icon: '📈'
      },
      {
        title: 'iOS və Android',
        description: 'Hər iki platformada tam funksionallıq',
        icon: '📲'
      }
    ]
  }
];